import React from "react"
import { useLocation } from "react-router"
import { useNavigate } from "react-router-dom"

import Logos from "../../../assets/Header_Icons/Logos.svg"
import Basket from "../../Basket"
import CountrySelect from "../../GlobalCountry"
import NavBar from "../../Navbar"
import Notification from "../../Notification"
import Profile from "../../Profile"

const Header = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { user_details }  = sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : ""
    const isLoginRoute = (location.pathname === "/" || location.pathname === "/registration" || location.pathname === "/home")
    console.log("isLoginRoute", isLoginRoute)
    
    const redirectToHome=()=>{
        if(user_details){
            navigate("/dashboard")
        } else {
            navigate("/")
        }
    }  

    return (
        <div className= "fixed w-full top-0 z-[10] no-print z-[11]">
            <div className="flex px-8 justify-between items-center bg-white" style={ { paddingRight:"0" } }>
                <div>
                    <img rel="preload" fetchPriority="high" src={ `${Logos}` } height={ "42px" } width={ "346px" } alt="header" />
                    <a href="javascript:void(0)" onClick= { redirectToHome } className={ "absolute top-px left-8 w-32 h-10 cursor-pointer" } title={ "logo" } ></a>
                </div>
                <div className= { user_details !==undefined ? "flex items-center justify-center gap-8" : "hidden" }>
                    { !isLoginRoute && (
                        <>
                            <Basket/>
                            { <Notification />  }
                            <Profile />
                        </>
                    )
                    }
                    <CountrySelect />
                </div>
            </div>
            { !isLoginRoute && <NavBar /> }
        </div>
    )
}

export default Header
